import type { ReactNode } from "react";
import Layout from "../layout";

export type ArticleLayoutProps = Parameters<typeof Layout>[0] & {
  instanceId?: string;
};

export default function ({ children, instanceId, ...props }: ArticleLayoutProps): ReactNode {
  return <Layout {...props}>{children}</Layout>;
}
